import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { LanguageService } from '../../../core/services/language.service';

export interface ModalAcceptNotificationsResult {
  accept: boolean;
}

@Component({
  selector: 'app-modal-accept-notifications',
  templateUrl: './modal-accept-notifications.component.html',
  styleUrls: ['./modal-accept-notifications.component.scss'],
})
export class ModalAcceptNotificationsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalAcceptNotificationsComponent>,
    public languageService: LanguageService
  ) {}

  ngOnInit(): void {}

  close(accept: boolean) {
    const modalResult: ModalAcceptNotificationsResult = {
      accept,
    };
    this.dialogRef.close(modalResult);
  }
}
